import { push } from './EasyLoisirsGTMClient';

const sendUXEventGTM = event => {
  push(event);
};

export default sendUXEventGTM;
